import type { MentionToken } from "./MentionToken";

/**
 * トークン列を本文へ戻す。{@link tokenizeMentions} の逆。
 *
 * **表示名を安全化しない。** 通すのは本文へ新しく名前を埋める側だけで、それは
 * {@link formatMention} が担う。読み取れた表示名は `](` を含みえないので埋め直しても
 * 壊れず、ここで安全化すると既存の表示名が勝手に全角へ変わる。
 *
 * 参照を差し替える書き換えは、分解 → トークンを直す → ここで戻す、の順で行う。独自の
 * 正規表現で本文を置換すると、表示名の規則が増えたときに置換だけが取り残される（記録 72）。
 */
export function serializeMentions(tokens: readonly MentionToken[]): string {
    let out = "";
    for (const token of tokens) {
        out += token.kind === "text" ? token.text : `@[${token.name}](${token.ref})`;
    }
    return out;
}
